// Lightweight, dependency-free client logger for the admin app.
// react-scripts 4 / webpack 4 can't bundle winston/pino (Node-only), so this is
// a thin console wrapper that mirrors the server logger's level names.
//
// Levels: debug < info < warn < error. In production only warn/error print, so
// app logs don't leak into a merchant's browser console. Override the threshold
// with REACT_APP_LOG_LEVEL (e.g. 'debug') when you need verbose output in prod.

const LEVELS = { debug: 10, info: 20, warn: 30, error: 40 }

const envLevel = (process.env.REACT_APP_LOG_LEVEL || '').toLowerCase()
const threshold =
  LEVELS[envLevel] ||
  (process.env.NODE_ENV === 'production' ? LEVELS.warn : LEVELS.debug)

const log = (level, ...args) => {
  if (LEVELS[level] < threshold) return
  // Some browsers hide console.debug behind a "verbose" filter; use log for it.
  const fn = level === 'debug' ? 'log' : level
  // eslint-disable-next-line no-console
  console[fn]('[TridentAB]', ...args)
}

const logger = {
  debug: (...args) => log('debug', ...args),
  info: (...args) => log('info', ...args),
  warn: (...args) => log('warn', ...args),
  error: (...args) => log('error', ...args),
}

export default logger
